var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFooterSearchOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Selected=True, Name=Search"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36 6C52.5685 6 66 19.4315 66 36C66 42.6614 63.8289 48.8156 60.1557 53.7938L66.182 59.818C67.9393 61.5754 67.9393 64.4246 66.182 66.182C64.5345 67.8295 61.9273 67.9325 60.1598 66.4909L59.818 66.182L53.7947 60.1551C48.8164 63.8286 42.6618 66 36 66C19.4315 66 6 52.5685 6 36C6 19.4315 19.4315 6 36 6ZM39.6905 40.0853C37.6845 42.5048 34.734 42.6317 32.6281 40.4634L32.0438 39.8281C30.9537 38.8112 29.2514 38.7415 28.0774 39.7217C26.8055 40.7835 26.6352 42.6754 27.6971 43.9472C32.2194 49.3641 39.8046 49.3485 44.3095 43.9147C45.367 42.6392 45.1902 40.7479 43.9147 39.6905C42.6392 38.633 40.7479 38.8098 39.6905 40.0853Z",
    fill: "#242424"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterSearchOn);
export default __webpack_public_path__ + "static/media/footer-search-on.17d862d18064c0e87a2c97a86b4d0e12.svg";
export { ForwardRef as ReactComponent };